import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../../../constants/constants";
import TblComp from "../../../../../react_table";
import { Button } from "reactstrap";
import {
  HandleTicketTypeFetch,
  editTicketType,
  HandleTicketTypeDelete,
} from "../../../../../actions/settings/types/ticket_type_actions";
import { clearTicketTypeForm } from "../../../../../actions/settings/types/ticket_type_actions";
import ExportCSV from "../../../../../constants/Exports/xlsExport";
import DeleteModal from "../../../../../constants/deleteModal";

export const TicketTypesTable = (props) => {
  const [modal, setModal] = useState(false);
  const [selected, setSelected] = useState(false);
  const toggle = () => setModal(!modal);
  const { loading_ticket_types, ticket_type_list, is_processing } = useSelector(
    (state) => state.tickettypereducer,
    shallowEqual
  );
  const dispatch = useDispatch();
  useEffect(() => {
    ticket_type_list.length === 0 && dispatch(HandleTicketTypeFetch());
  }, [dispatch, ticket_type_list.length]);

  const headers = ["Id", "Title", "Description"];

  return (
    <>
      <DeleteModal
        modal={modal}
        toggle={toggle}
        name="ticket type"
        handleDelete={() => dispatch(HandleTicketTypeDelete(selected, toggle))}
        is_processing={is_processing}
      />
      <Button
        className="btn ticket-btn my-3 me-2"
        onClick={(e) => {
          dispatch(clearTicketTypeForm(e));
          props.toggle();
        }}
      >
        Add Ticket Type
      </Button>
      <ExportCSV
        csvData={ticket_type_list}
        fileName="ticketypes"
        headers={headers}
      />
      <TblComp
        columns={[
          {
            Header: "Title",
            accessor: "ticket_type_name",
            filter: "fuzzyText",
          },
          {
            Header: "Description",
            accessor: "description",
            filter: "fuzzyText",
          },
          {
            id: "actions", // Required because our accessor is not a string
            Header: "Action",
            maxWidth: 100,
            accessor: (full) => (
              <Actions
                editHandler={(selected_row) => [
                  dispatch(editTicketType(selected_row)),
                  props.toggle(),
                ]}
                data_item={full}
                link_url={""}
                deleteHandler={(selected_id) => [
                  toggle(),
                  setSelected(selected_id.id),
                ]}
              />
            ),
          },
        ]}
        data={ticket_type_list}
        loading={loading_ticket_types}
      />
    </>
  );
};
